import { createContext, useContext } from "react";
import type { GateKind } from "@/lib/gate";
import type { ToolJob } from "@/lib/tools/pastedJob";

export interface Gate {
    /** Opens the sheet for an action: a visitor's way in, or a free account's way to a plan. */
    ask: (kind: GateKind, postingId?: string, pasted?: ToolJob) => void;
}

/** The sheets, given by GateProvider (./Gate); nothing opens outside it. */
export const GateContext = createContext<Gate>({ ask: () => {} });

/** The sheets, from anywhere under the site's frame. */
export function useGate(): Gate {
    return useContext(GateContext);
}
